import { httpClient } from '@/services/http/httpClient'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'

export type GetMyProjectsResponse = {
  projects: {
    id: string
    title: string
    description: string
    status: string
    createdAt: string
    endDate: string
    portfolioColumn: {
      id: string
      title: string
    }
    projectUsers: {
      id: string
      name: string
      email: string
      image: string
    }[]
    totalUsers: number
  }[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

export const getMyProjects = async ({
  query,
}: {
  query: QueryParams & { type: 'all' | 'responsible' | 'member' }
}): Promise<GetMyProjectsResponse> => {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get(
    `/projects/portfolio-projects/my-projects?${queryParams}`,
  )

  return {
    projects: data.projects,
    pagination: data.paginate,
  }
}
